const article = {
    slug: "soshiotsuki",
    category: "BRAND BUYBACK",
    listTitle: "SOSHIOTSUKI買取",
    listDescription:
      "LVMH Prize受賞歴だけでなく、シーズン、テーラリング、シグネチャーデザインまで見て査定するEnclopediaのブランド別買取ページ。",
    seo: {
      title:
        "SOSHIOTSUKI買取｜ソウシオオツキのアーカイブ価値まで査定するEnclopedia",
      description:
        "SOSHIOTSUKIの買取ならEnclopediaへ。大月壮士によるテーラリング、Inside Lapel Jacket、希少アーカイブ、LVMH Prize受賞前後のシーズン背景まで確認して査定します。まずはLINE事前査定からご相談ください。",
      keyword:
        "SOSHIOTSUKI 買取,ソウシオオツキ 買取,SOSHIOTSUKI 高価買取,ソウシオオツキ 高価買取,SOSHIOTSUKI 宅配買取,大月壮士,LVMH Prize,Inside Lapel Jacket,インサイドラペルジャケット,ドメスティックブランド 買取,デザイナーズブランド 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/soshiotsuki",
    },
  
    hero: {
      label: "SOSHIOTSUKI BUYBACK",
      number: "01 / BUYBACK",
      titleLines: [
        "SOSHIOTSUKI買取。",
        "日本のテーラリングの現在地まで見て査定します。",
      ],
      body:
        "Enclopediaは、SOSHIOTSUKIをLVMH Prize受賞ブランドという肩書だけで判断しません。\n大月壮士が追究してきた日本人とスーツの関係、シーズンごとの思想、パターンとディテール、現在の希少性まで確認します。\nまずはLINEで事前にご相談いただき、個々の服に適した宅配買取へつなげます。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "Japanese tailoring",
        "LVMH Prize 2025",
        "inside lapel",
        "archive valuation",
      ],
      visualLabel: "JAPANESE TAILORING",
      visualTitle: [
        "受賞歴ではなく、",
        "スーツの中にある日本性を見る。",
      ],
      image: "media/archive_fashion/buyback-soshiotsuki.png",
      imageAlt:
        "SOSHIOTSUKIのテーラリングとアーカイブ買取を表現したメイン画像",
    },
  
    thesis: {
      text:
        "西洋のスーツが日本でどのように変形し、新しい伝統になろうとしているのか。その過程まで査定する。",
      keywords: ["tailoring", "drape", "Japanese identity"],
    },
  
    intro: {
      label: "02 / DESIGNER & BRAND",
      titleLines: [
        "大月壮士が作るのは、",
        "着物の引用だけではない日本の服。",
      ],
      body:
        "デザイナーの大月壮士は1990年に千葉県で生まれ、文化服装学院のメンズウェア科と「ここのがっこう」で学びました。\n2015年にSOSHIOTSUKIを立ち上げ、第2コレクションで2016年LVMH Prizeのショートリストに選出。約9年後の2025年、同賞を受賞しました。\n\n初期には古典芸能、喪服、作務衣などから日本人の精神性を探り、近年はバブル期のサラリーマンや1980年代のイタリアンスーツを通して、日本人が西洋服を受け入れてきた歴史を再解釈しています。\nSOSHIOTSUKIの価値は、和の記号を付け加えることではなく、日本人の身体、姿勢、労働、憧れによって変形したスーツを、新しい日本の服として提示している点にあります。",
    },
  
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つのSOSHIOTSUKI査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "シーズンごとの思想を見る",
          text:
            "古典芸能、喪服、作務衣、サラリーマン、昭和・バブル期のスーツなど、どの時期の研究から生まれた服なのかを確認します。",
        },
        {
          number: "02",
          title: "テーラリングの構造を見る",
          text:
            "ラペルの返り、肩の設計、身頃の余白、ドレープ、パンツのタックなど、写真だけでは伝わりにくいパターンと構造を評価します。",
        },
        {
          number: "03",
          title: "シグネチャーと希少性を見る",
          text:
            "Inside Lapel Jacketをはじめとする代表作、ルック使用品、初期作品、限定的な流通アイテムは、現在の需要と再入手難度を含めて個別に査定します。",
        },
      ],
    },
  
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "SOSHIOTSUKIの主要カテゴリーを、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "Inside Lapel Jacket",
          text:
            "裏側や芯地の構造を表へ反転させた、ブランドを代表するテーラードジャケット。年代、素材、仕様、保存状態を細かく確認します。",
        },
        {
          tag: "ITEM 02",
          title: "テーラードジャケット・セットアップ",
          text:
            "シングル、ダブル、ショールカラーなどを問わず、肩の設計やドレープにブランド性が強く現れたモデルを重点的に査定します。",
        },
        {
          tag: "ITEM 03",
          title: "トラウザーズ",
          text:
            "深いタック、ゆとりのある腰回り、落ち感のあるワイドシルエットなど、ジャケットと一体で設計されたパンツを評価します。",
        },
        {
          tag: "ITEM 04",
          title: "コート・レザーブルゾン・アウター",
          text:
            "ロングコート、トレンチ、レザーブルゾンなど、テーラリングの考え方を外衣へ展開したアイテムも対象です。",
        },
        {
          tag: "ITEM 05",
          title: "作務衣・着物構造を応用したシャツ",
          text:
            "Kimono Breasted Shirtや作務衣風シャツなど、日本の衣服構造を日常着へ置き換えたアイテムを丁寧に確認します。",
        },
        {
          tag: "ITEM 06",
          title: "LVMH Prize受賞前後のコレクション",
          text:
            "近年のブランド像を確立したテーラリングや、海外評価の高まりと結び付くシーズンは、アイテム単位で現在価値を見ます。",
        },
      ],
    },
  
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "SOSHIOTSUKIのアイテム。",
      ],
      intro:
        "SOSHIOTSUKIは二次流通市場が形成途中のブランドです。受賞歴だけで価格を決めず、作品性、需要、流通数、状態を総合して判断します。",
      items: [
        {
          index: "01",
          title: "Inside Lapel Jacketなどの代表作",
          text:
            "ブランドの設計思想を明確に示すシグネチャーモデルは、通常のテーラードジャケットと区別して評価します。",
        },
        {
          index: "02",
          title: "完成度の高いスーツ・セットアップ",
          text:
            "ジャケットとトラウザーズが揃い、独特の肩、ラペル、ドレープ、丈のバランスが保たれているものは評価につながりやすくなります。",
        },
        {
          index: "03",
          title: "ルック使用品・シーズンを象徴する服",
          text:
            "公式ルック、ショー、展示会、主要メディアで使用された型や、そのシーズンのテーマを明確に示すアイテムを丁寧に見ます。",
        },
        {
          index: "04",
          title: "流通量の少ない初期作品・限定品",
          text:
            "初期アーカイブや限定的な生産品は、古さだけでなく、来歴、保存状態、資料性、現在の需要を確認して個別に評価します。",
        },
      ],
    },
  
    quote: {
      textLines: [
        "日本の服を、和服の記号で終わらせない。",
        "スーツの中に生まれた日本性まで見る。",
      ],
    },
  
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定では、",
        "見落とされやすいSOSHIOTSUKIの価値。",
      ],
      intro:
        "SOSHIOTSUKIは、一見すると端正なスーツに見える服の内側へ、パターン操作や文化的な違和感を組み込んでいます。",
      items: [
        {
          index: "01",
          title: "LVMH Prizeの肩書だけで価格を決めない",
          text:
            "受賞はブランド評価を高める重要な出来事ですが、すべての製品が一律に高額になるわけではありません。型、年代、需要、状態を分けて確認します。",
        },
        {
          index: "02",
          title: "“Armani風のスーツ”で終わらせない",
          text:
            "1980年代のイタリアンテーラリングからの影響だけでなく、それが日本人の身体や社会へ移された際のずれまで含めて作品を見ます。",
        },
        {
          index: "03",
          title: "外見だけでなく服の内側を見る",
          text:
            "ラペルをめくった構造、芯地、裏地、ポケット、背襟の意匠など、着用画像だけでは判断しにくいディテールも査定対象です。",
        },
      ],
    },
  
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: ["LINE事前査定から、", "宅配買取へ。"],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "全体写真、品質表示タグ、品番、サイズ、状態が分かる写真をお送りください。シーズンが不明な場合も確認します。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。ご自身の箱または選択制の宅配キットで商品をお送りください。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "実物の構造、状態、真贋、市場性を確認します。金額にご納得いただければ、ご指定口座へ入金します。",
        },
      ],
    },
  
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: ["相談しやすく、", "背景まで確認する宅配買取。"],
      intro:
        "シーズンや品名が分からない場合も、LINEで写真を確認してから宅配買取へ進めます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "写真とタグ情報から事前に確認するため、査定対象か分からない場合も相談できます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合は、そのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
  
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "SOSHIOTSUKI買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question: "SOSHIOTSUKIはどのようなブランドですか？",
          answer:
            "大月壮士が2015年に設立した日本のファッションブランドです。日本の古典芸能や精神性を出発点としながら、近年はサラリーマン、昭和・バブル期、イタリアンスーツなどを通して、日本人と西洋服の関係をテーラリングで再解釈しています。",
        },
        {
          question:
            "LVMH Prize受賞アイテムは必ず高くなりますか？",
          answer:
            "受賞によってブランドへの国際的な注目は高まりましたが、すべての製品が一律に高額になるわけではありません。モデル、シーズン、流通数、需要、状態を総合して査定します。",
        },
        {
          question:
            "どのようなSOSHIOTSUKIが高価買取につながりやすいですか？",
          answer:
            "Inside Lapel Jacket、完成度の高いセットアップ、公式ルック使用品、シーズンを象徴するアウター、流通量の少ない初期作品などは、丁寧な評価につながりやすい傾向があります。",
        },
        {
          question:
            "シーズンや正式な商品名が分からなくても査定できますか？",
          answer:
            "可能です。服の全体、ブランドタグ、品質表示タグ、品番、ディテールが分かる写真をLINEでお送りください。確認できる範囲で年代やモデルを調査します。",
        },
        {
          question:
            "ジャケットだけ、パンツだけでも査定できますか？",
          answer:
            "単品でも査定可能です。セットアップとして販売された製品は上下が揃っている方が評価しやすい場合がありますが、単品の需要やデザイン性も確認します。",
        },
      ],
    },
  
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "SOSHIOTSUKIの価値をご相談ください。",
      ],
      body:
        "LVMH Prizeという肩書だけでなく、その服がどのような日本のテーラリングを表しているのかまで確認します。\n写真による事前査定から、背景を理解した宅配買取へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };
  
  export default article;